import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, AfterContentInit, ViewEncapsulation  } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule, MatStepper } from '@angular/material/stepper';
import { Global } from 'src/app/shared/global';
import { BasicComponent } from 'src/app/modals/basic/basic.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-educational-content',
  templateUrl: './educational-content.component.html',
  styleUrls: ['./educational-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class EducationalContentComponent implements OnInit, AfterViewInit {
  eduObject;
  selectedTabIndex = 0;
  //selectedTabArray = [];
  //selectedTabColor = 'primary';//"#00D992";
  expandedStep: number = 1;//-1;
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('table', { static: true }) table: ElementRef;

  constructor(public global: Global, private dialog: MatDialog) {
    this.eduObject = this.global.getEduLessonObj;
    //this.eduObject[this.global.selectedEduCategory].selected = true;
    this.selectedTabIndex = this.global.selectedEduCategory;
   }

  ngOnInit(): void {
    
  }

  ngAfterViewInit (){
    this.setNecessaryElements();
  }

  setNecessaryElements(){
    var basicDialog = this.dialog;
    //set quick timeout after angular fully loads everything
    setTimeout(() => {
      // Access and manipulate the content here
      //if(this.table){
        //console.log('table?', this.table);
        //NOTE: cant use ids in html stored in DB - they will be stripped on load = use classes
        
        //Medicare 101 > Medicare Alphabet
        //let medicareAlphabetElement = document.getElementById('medicareAlphabet');
        let medicareAlphabetRowsElement = document.getElementsByClassName('medicareAlphabetRow') as HTMLCollectionOf<HTMLElement>;
        if(medicareAlphabetRowsElement){
          //medicareAlphabetElement.addEventListener("click", (e:Event) => this.getTrainingName(4));
          //const rows = medicareAlphabetElement.getElementsByClassName("myRow");
          console.log('something something');
          for (let i = 0; i < medicareAlphabetRowsElement.length; i++) {
              medicareAlphabetRowsElement[i].onclick = function() {
              //console.log('in obj', medicareAlphabetRowsElement[i]);

              const modalTitle = medicareAlphabetRowsElement[i].querySelectorAll("tr > td:first-child")[0].innerHTML;
              const modalSubTitle = medicareAlphabetRowsElement[i].querySelectorAll("tr > td")[1].innerHTML;
              const modalContent = medicareAlphabetRowsElement[i].querySelectorAll("tr > td:last-child")[0].innerHTML;

              const dialogRef = basicDialog.open(BasicComponent, {     
                data: { title: modalTitle + ': ' + modalSubTitle, content: modalContent }
              });
              
              dialogRef.afterClosed().subscribe(result => {
                if(result){
                
                }
              });
                
            };
          }
        }

        //Medicare 101 > Original Medicare vs Medicare Adv
        let medicareVSAdvantageElement = document.getElementsByClassName('flip-card-inner-medicareVSAdvantageElement') as HTMLCollectionOf<HTMLElement>;
        if(medicareVSAdvantageElement){          

          for (let i = 0; i < medicareVSAdvantageElement.length; i++) {
            medicareVSAdvantageElement[i].onclick = function() {                
              const modalTitle = medicareVSAdvantageElement[i].querySelectorAll("tr > td:first-child")[0].innerHTML;
                //const modalSubTitle = medicareVSAdvantageElement[i].querySelectorAll("tr > td")[1].innerHTML;
                const modalContent = medicareVSAdvantageElement[i].querySelectorAll("tr > td:last-child")[0].innerHTML;
                const dialogRef = basicDialog.open(BasicComponent, {     
                  data: { title: modalTitle, content: modalContent }
                });
                
                dialogRef.afterClosed().subscribe(result => {
                  if(result){
                  
                  }
                });   
            };
          }
        }

        //Cost Factors > Health Insurance Options > flip cards
        let flipCardsElement = document.getElementsByClassName('flip-card-inner') as HTMLCollectionOf<HTMLElement>;
        if(flipCardsElement){
          for (let i = 0; i < flipCardsElement.length; i++) {
            flipCardsElement[i].onclick = function() {                
                if(!flipCardsElement[i].classList.contains('flip-card-flips')){
                  flipCardsElement[i].classList.add('flip-card-flips');
                } else {
                  flipCardsElement[i].classList.remove('flip-card-flips');
                }                
            };
          }
        }
      //  }
    }, 20);
  }

  onTabSelection(event){
    //console.log('changed tab', event.index);
    //this.stepper.selectedIndex = 0;
    //this.selectedTabArray.push(event.index);

    //reset previously clicked
    this.eduObject[this.selectedTabIndex].previouslySelected = true;
    this.eduObject[this.selectedTabIndex].isSelected = false;

    //set just clicked
    this.selectedTabIndex = event.index;
    this.global.selectedEduCategory = this.selectedTabIndex;
    this.eduObject[this.selectedTabIndex].previouslySelected = false;
    this.eduObject[this.selectedTabIndex].isSelected = true;

    //set coach
    this.global.selectedEduCatLesson = 0;
    this.global.getCoachTxt = this.global.getEduLessonObj[this.global.selectedEduCategory].lessons[this.global.selectedEduCatLesson].guideMessage; 

    //when switching tabs, the elements get messed up - set them again
    this.setNecessaryElements();
  }

  onStepOpened(index: number) {
    /* this.expandedStep = index;
    this.stepper.selectedIndex = index;

    console.log('selected step index', index);
    console.log('selected stepper index', this.stepper.selectedIndex); */
  }

  onStepSelection(event){
    /* console.log('selecteed step', event);

    this.expandedStep = event.selectedIndex;
    this.stepper.selectedIndex = event.selectedIndex; */

    this.global.selectedEduCatLesson = event.selectedIndex;//(event.selectedIndex - 1);

    //set coach
    this.global.getCoachTxt = this.global.getEduLessonObj[this.global.selectedEduCategory].lessons[this.global.selectedEduCatLesson].guideMessage; 
  }

}
